import React, { useState, useRef, useEffect } from 'react';
import { Send } from 'lucide-react';
interface RefineInputProps {
  onSubmit: (comment: string) => void;
  onCancel: () => void;
}
export function RefineInput({
  onSubmit,
  onCancel
}: RefineInputProps) {
  const [comment, setComment] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    inputRef.current?.focus();
  }, []);
  const handleSubmit = () => {
    if (comment.trim()) {
      onSubmit(comment.trim());
      setComment('');
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
    if (e.key === 'Escape') {
      e.preventDefault();
      onCancel();
    }
  };
  return <div className="flex items-center gap-2 px-4 pb-2" data-id="element-274">
      <input ref={inputRef} value={comment} onChange={e => setComment(e.target.value)} onKeyDown={handleKeyDown} placeholder="What should change?" className="flex-1 bg-white/[0.04] text-[#e8e4df] text-[13px] rounded-lg px-3 py-2 outline-none placeholder:text-[#8a8680]/50 focus:ring-1 focus:ring-[#4a9a9a]/30" data-id="element-275" />
      <button onClick={handleSubmit} disabled={!comment.trim()} className="p-2 rounded-lg bg-[#4a9a9a] text-[#141418] transition-opacity disabled:opacity-30 hover:bg-[#5bb5b5]" data-id="element-276">
        <Send size={14} data-id="element-277" />
      </button>
    </div>;
}